import styled from 'styled-components';

export const FilterRows = styled.div`
    /* Surtout PAS d'overflow ici : un conteneur de défilement capture les menus
       déroulants des filtres (position: absolute) au lieu de les laisser se
       superposer, obligeant à défiler dans la div pour voir les options.
       Sur écran étroit on laisse donc les lignes passer à la ligne. */
    > div {
        flex-wrap: wrap;
    }
`;

export const FilterActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
`;

export const FilterError = styled.div`
    background: ${(p) => p.theme.dangerSoft};
    color: ${(p) => p.theme.danger};
    border-radius: ${(p) => p.theme.radius.sm};
    padding: 0.65rem 0.9rem;
    font-size: ${(p) => p.theme.type.body};
    margin-bottom: 16px;
`;
